var _excluded = ["droppableId", "children", "items", "itemControl", "getListStyle", "getItemStyle", "portalControl", "hidePlaceholder"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/jsx-props-no-spreading */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Droppable as DroppableDnd } from 'react-beautiful-dnd';
import { Draggable } from '.';

/**
 * Droppable component.
 *
 * @param {*} props
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Droppable = function Droppable(props) {
  var droppableId = props.droppableId,
    _children = props.children,
    items = props.items,
    itemControl = props.itemControl,
    getListStyle = props.getListStyle,
    getItemStyle = props.getItemStyle,
    portalControl = props.portalControl,
    hidePlaceholder = props.hidePlaceholder,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var getStyle = function getStyle(snapshot) {
    if (!_.isNil(getListStyle)) {
      return _.invoke(props, 'getListStyle', snapshot);
    }
    return {
      background: 'transparent'
    };
  };
  var handleItemStyle = function handleItemStyle(snapshot, provided) {
    var _ref = provided || {},
      draggableProps = _ref.draggableProps;
    var _ref2 = draggableProps || {},
      style = _ref2.style;
    if (!_.isNil(getItemStyle)) {
      return getItemStyle(snapshot, provided);
    }
    return Object.assign({}, style);
  };
  if (!_.isNil(_children) && !_.isEmpty(_children)) {
    return /*#__PURE__*/_jsx(DroppableDnd, Object.assign({
      droppableId: droppableId,
      renderClone: function renderClone(provided, snapshot, rubric) {
        return /*#__PURE__*/_jsx("div", Object.assign({}, provided.draggableProps, provided.dragHandleProps, {
          ref: provided.innerRef,
          style: handleItemStyle(snapshot, provided),
          children: /*#__PURE__*/React.isValidElement(portalControl) ? /*#__PURE__*/React.cloneElement(portalControl, {
            dragProps: provided.dragHandleProps
          }) : /*#__PURE__*/React.createElement(portalControl, Object.assign({
            dragProps: provided.dragHandleProps
          }, items[rubric.source.index]))
        }));
      }
    }, rest, {
      children: function children(provided, snapshot) {
        return /*#__PURE__*/_jsxs("div", Object.assign({}, provided.droppableProps, {
          ref: provided.innerRef,
          style: getStyle(snapshot),
          children: [_children, hidePlaceholder ? /*#__PURE__*/_jsx("div", {
            style: {
              visibility: 'hidden'
            },
            children: provided.placeholder
          }) : provided.placeholder]
        }));
      }
    }));
  }
  return /*#__PURE__*/_jsx(DroppableDnd, Object.assign({
    droppableId: droppableId,
    renderClone: function renderClone(provided, snapshot, rubric) {
      return /*#__PURE__*/_jsx("div", Object.assign({}, provided.draggableProps, provided.dragHandleProps, {
        ref: provided.innerRef,
        style: handleItemStyle(snapshot, provided),
        children: /*#__PURE__*/React.isValidElement(itemControl) ? /*#__PURE__*/React.cloneElement(itemControl, {
          dragProps: provided.dragHandleProps
        }) : /*#__PURE__*/React.createElement(itemControl, Object.assign({
          dragProps: provided.dragHandleProps
        }, items[rubric.source.index]))
      }));
    }
  }, rest, {
    children: function children(provided, snapshot) {
      return /*#__PURE__*/_jsxs("div", Object.assign({}, provided.droppableProps, {
        ref: provided.innerRef,
        style: getStyle(snapshot),
        children: [_.map(items, function (item, index) {
          if ( /*#__PURE__*/React.isValidElement(item)) {
            return item;
          }
          return /*#__PURE__*/_jsx(Draggable, {
            control: itemControl,
            draggableId: !_.isNil(item.key) ? item.key : "draggable-" + index,
            index: index,
            item: item,
            getItemStyle: getItemStyle
          }, !_.isNil(item.key) ? item.key : "draggable-" + index);
        }), hidePlaceholder ? /*#__PURE__*/_jsx("div", {
          style: {
            visibility: 'hidden'
          },
          children: provided.placeholder
        }) : provided.placeholder]
      }));
    }
  }));
};

/** Proptypes. */
Droppable.handledProps = ["children", "droppableId", "getItemStyle", "getListStyle", "hidePlaceholder", "itemControl", "items", "portalControl"];
Droppable.propTypes = {
  /**  Shorthand array of props for Droppable */
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.array,
  /** Droppable id. */
  droppableId: PropTypes.string,
  /** An item control component. */
  itemControl: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  /** Function to get style list. */
  getListStyle: PropTypes.func,
  /** Function to get style item. */
  getItemStyle: PropTypes.func,
  /** Primary content. */
  children: PropTypes.node,
  /** Control in the portal. */
  portalControl: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.symbol]),
  /** Hide the placeholder. */
  hidePlaceholder: PropTypes.bool
};

/** Default props. */
Droppable.defaultProps = {
  droppableId: 'droppable',
  hidePlaceholder: true
};
export default Droppable;